import { render, staticRenderFns } from "./AddEditCharges.vue?vue&type=template&id=1142c813"
import script from "./AddEditCharges.vue?vue&type=script&lang=js"
export * from "./AddEditCharges.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports